export default __webpack_public_path__ + "static/media/5329@2x.40605958.webp";